import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://0f5c3c52a04f2356b4c03baeb961efc2@o4507143059013632.ingest.de.sentry.io/4507143063732304",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    "uryungfzhnbhrk4l5ft2nuayg4.appsync-api.eu-north-1.amazonaws.com",
    "cognito-identity.eu-north-1.amazonaws.com",
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: import.meta.env.VITE_ENVIRONMENT ?? "development",
});

import ReactDOM from "react-dom/client";

import React from "react";
import { ThemeProvider } from "@aws-amplify/ui-react";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";

import { Amplify } from "aws-amplify";
import { Helmet } from "react-helmet";

import { setupI8n } from "./i18n";

import outputs from "../amplify_outputs.json";

const cognitoDomainMapping: { [key: string]: string } = {
  "virtualcoach-sandbox-moha.auth.eu-north-1.amazoncognito.com":
    "moha-sandbox-auth.virtualcoach.dance",
  "virtualcoach-sandbox.auth.eu-north-1.amazoncognito.com":
    "sandbox-auth.virtualcoach.dance",
  "auth.virtualcoach.dance.auth.eu-north-1.amazoncognito.com":
    "auth.virtualcoach.dance",
  "b3d984178b74f2b06266.auth.eu-north-1.amazoncognito.com":
    "auth.virtualcoach.dance",
};

outputs.auth.oauth.domain =
  cognitoDomainMapping[outputs.auth.oauth.domain] || outputs.auth.oauth.domain;

Amplify.configure(outputs);

setupI8n();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <React.StrictMode>
      <Helmet>
        <title>Virtual Dance Coach</title>
      </Helmet>
    </React.StrictMode>
    <ThemeProvider>
      <Sentry.ErrorBoundary
        fallback={<p>Oops please go to the previous screen.</p>}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  </>
);
